export const generarHTMLTicket = (tipo, p, anchoMm = 80) => {
    const ordenId = p.display_id || p.id || '---';
    const cliente = (p.nombre_cliente || 'VENTA TPV').toUpperCase();

    const ahora = new Date();
    const fechaFmt = `${ahora.getDate()}/${ahora.getMonth() + 1}/${ahora.getFullYear()} ${ahora.getHours()}:${ahora.getMinutes().toString().padStart(2, '0')}`;

    const modo = (p.lugar_consumo || 'PARA SERVIR').toUpperCase();
    const esLlevar = modo.includes('LLEVAR');
    const items = p.cartItems || p.items || [];

    // --- TABLA DE ITEMS ---
    const htmlItems = items.map(it => {
        const cant = parseFloat(it.cantidad || 1);
        const nombre = it.nombre.toUpperCase();
        const precio = parseFloat(it.precio || 0);
        const subtotal = Math.round(cant * precio);

        if (tipo === 'COMANDA') {
            return `
                <tr>
                    <td colspan="2" style="font-size: 1.1em; font-weight: bold; padding-top: 5px;">
                        ${cant}x ${nombre}
                    </td>
                </tr>
                ${it.variantes_detalles ? `<tr><td colspan="2" style="font-size: 0.9em; padding-left: 10px;">>> ${it.variantes_detalles}</td></tr>` : ''}
            `;
        } else {
            return `
                <tr>
                    <td style="font-size: 0.95em; padding-top: 3px; vertical-align: top;">
                        ${cant}x ${nombre}
                    </td>
                    <td style="font-size: 0.95em; text-align: right; font-weight: bold; vertical-align: top; white-space: nowrap;">
                        $${subtotal.toLocaleString('es-CL')}
                    </td>
                </tr>
                ${it.variantes_detalles ? `<tr><td colspan="2" style="font-size: 0.85em; padding-left: 10px;">> ${it.variantes_detalles}</td></tr>` : ''}
            `;
        }
    }).join('');

    return `
        <html>
            <head>
        <style>
    @page { 
        margin: 0 !important; 
    }
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        background: #FFF;
    }
    body { 
        /* 🚩 Forzamos el ancho para que Chrome entienda que NO es una A4 */
        width: ${anchoMm === 80 ? '79mm' : '56mm'}; 
        font-family: 'Courier New', Courier, monospace; 
        color: black;
        /* Subimos la fuente a un tamaño que se lea a 1 metro de distancia */
        font-size: ${anchoMm === 80 ? '14pt' : '11pt'}; 
        line-height: 1.2;
    }
    table { 
        width: 100%; 
        border-collapse: collapse; 
        margin: 5px 0;
    }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .bold { font-weight: 900; }
    .divider { border-top: 2px dashed black; margin: 8px 0; }
    
    /* El número de orden tiene que ser EL REY del ticket */
    .num-orden {
        font-size: 4em; /* Gigante */
        font-weight: 900;
        display: block;
        line-height: 1;
        margin: 10px 0;
    }
</style>
            </head>
            <body>
                <div class="text-center">
                    <span style="font-size: 0.8em;">-- ${tipo === 'COMANDA' ? 'COMANDA' : 'RECIBO'} --</span><br>
                    <span style="font-size: 2.8em; font-weight: 900; line-height: 1;">#${ordenId}</span><br>
                    ${tipo === 'COMANDA' ? `<div class="${esLlevar ? 'modo-tag bold' : 'bold'}">${esLlevar ? '🚩 PARA LLEVAR 🚩' : 'PARA SERVIR'}</div>` : ''}
                </div>

                <div style="font-size: 0.8em; margin-top: 5px;">
                    FECHA: ${fechaFmt}<br>
                    CLIENTE: ${cliente.substring(0, 20)}
                </div>

                <div class="divider"></div>
                <table>
                    ${htmlItems}
                </table>
                <div class="divider"></div>

                ${tipo !== 'COMANDA' ? `
                    <table style="margin-top: 5px;">
                        ${p.propina > 0 ? `
                        <tr>
                            <td style="font-size: 0.95em; text-align: right; padding-bottom: 3px;">
                                SUBTOTAL: $${Math.round((p.total || 0) - (p.propina || 0)).toLocaleString('es-CL')}
                            </td>
                        </tr>
                        <tr>
                            <td style="font-size: 0.95em; text-align: right; color: #2563eb; padding-bottom: 3px;">
                                PROPINA: +$${Math.round(p.propina || 0).toLocaleString('es-CL')}
                            </td>
                        </tr>
                        ` : ''}
                        <tr>
                            <td style="font-size: 1.3em; font-weight: bold; text-align: right;">
                                TOTAL: $${Math.round(p.total || 0).toLocaleString('es-CL')}
                            </td>
                        </tr>
                        <tr>
                            <td style="font-size: 0.85em; text-align: right;">
                                PAGO: ${p.metodo_pago || 'EFECTIVO'}
                            </td>
                        </tr>
                    </table>
                ` : ''}

                <div style="margin-top: 30px; text-align: center;">.</div>
            </body>
        </html>
    `;
};